import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App.tsx";
import "./index.css";
import * as Sentry from "@sentry/react";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";

// Windows Chrome/Firefox render regional-indicator flag emoji (used for
// language selectors) as plain two-letter codes instead of flags. This
// feature-detects that gap and swaps in a flag-only webfont where needed.
polyfillCountryFlagEmojis();

// import.meta.env.PROD alone isn't enough to gate this: `vite preview` also
// serves a production-mode build, so it's PROD too. VITE_DISABLE_SENTRY is
// set inline in package.json's dev/preview scripts (not documented as a
// developer-facing .env setting) so this is disabled automatically for both.
if (import.meta.env.PROD && !import.meta.env.VITE_DISABLE_SENTRY) {
  Sentry.init({
    dsn: "https://8330314e3224291d7b808ee643710176@o4503929032998912.ingest.us.sentry.io/4507942488440832",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
